import EmptyTable from "../../Common/EmptyTable";

/**
 * Standard empty / error / filter-empty state for Investment Hub tables.
 * Preserves page chrome — only replaces the table body via noDataComponent.
 */
export default function InvestorPortalTableEmpty({
  variant = "empty",
  title,
  description,
  ctaLabel,
  onCta,
}) {
  const presets = {
    empty: {
      title: title || "No records yet.",
      description: description || "",
      ctaLabel: ctaLabel || undefined,
    },
    filtered: {
      title: title || "No results match your filters.",
      description: description || "Try adjusting search or filters.",
      ctaLabel: ctaLabel || "Clear Filters",
    },
    error: {
      title: title || "We couldn’t load this data.",
      description: description || "Check your connection and try again.",
      ctaLabel: ctaLabel || "Try Again",
    },
  };

  const preset = presets[variant] || presets.empty;
  const message = (
    <div>
      <div className="fw-semibold text-black1 mb-1">{preset.title}</div>
      {preset.description ? (
        <div className="small text-muted mb-0" style={{ maxWidth: 360, margin: "0 auto" }}>
          {preset.description}
        </div>
      ) : null}
    </div>
  );

  return (
    <EmptyTable
      Message={message}
      btnText={onCta ? preset.ctaLabel : undefined}
      onClick={onCta}
    />
  );
}
